<!--
  a11y: modal dialog + focus trap on mobile so SR/Tab stay in the line results
  panel; initial focus is on the first action button in the tab content (see
  app-detailed-result-buttons focusInitialOnFirst), not the hour field.
-->
<design-slide-up-card #card [isCardOpen]="!!isCardOpen" class="route-planning-results" [showLogoInHeader]="true"
  [showBackgroundImage]="true" [title]="routePlanningText" [hideHeaderInDesktop]="true" [class]="direction"
  [roleDialog]="true" [trapFocusOnOpen]="!!isMobile">
  @if (isNavigatingToRoute) {
  <app-loader />
  }
  <app-results-header (onBackClick)="handleCloseClick(false)">
    <ng-container navigationButtons>
      <div class="flex items-center gap-2">
        <div class="bg-[#ffffff33] p-1 flex items-center justify-center">
          <img [src]="data.line.agencyId | agencyLogo" [attr.alt]="data.line.agencyName"
            class="h-6 hover:cursor-pointer" (click)="openAgencyContact(false, data.line.agencyId)" />
        </div>
        <h2 class="text-bold text-base m-0 font-bold !text-white">{{ data.line.routeName }}</h2>
      </div>
    </ng-container>

    <ng-container buttons>
      <mot-button type="button" icon="share-nodes" iconClass="text-2xl" buttonClass="!text-white" [text]="shareText"
        (onClick)="openShareLinkPopup()" ariaHaspopup="dialog" />

      <mot-menu [menuVert]="false" [menuItems]="moreActionsMenuItems" [menuButtonAriaLabel]="moreActionsMenuText"
        dir="rtl" buttonClass="!rounded-xl !text-white !w-8 !h-8 !min-w-0"
        buttonActiveClass="!rounded-xl !bg-white !w-8 !h-8 !min-w-0 !text-[#0C3058]" />
    </ng-container>

    <ng-container content class="flex flex-col gap-2">
      <span class="flex gap-2 items-center text-base px-4">
        <ng-icon class="text-primary-gold text-2xl" name="circle-dot" />
        <mot-select [formControl]="boardingStationFormControl" [options]="boardingStops$"
          [compareWith]="compareStopsByCode" [label]="boardingStationText" [hasTrigger]="true"
          [customOptionTemplate]="optionTemplate" [displayErrors]="false" selectClass="!text-white"
          labelClass="!text-primary-gold" class="station-select rounded-lg text-white w-full text-start">
          <div trigger>
            <span class="!text-base">{{ getStopName(boardingStationFormControl.value) }} @if
              (boardingStationFormControl.value?.platformNumber) {
              <span class="!text-base">- {{ platformText }} {{ boardingStationFormControl.value?.platformNumber }}</span>
              }</span>
            <small class="text-sm">
              - {{ boardingStationFormControl.value?.stopcode }}</small>
          </div>
        </mot-select>
      </span>

      <span class="flex gap-2 items-center text-base px-4">
        <ng-icon class="text-primary-gold text-2xl" name="location-dot" />
        <mot-select [formControl]="dropingStationFormControl" [options]="dropingStops$"
          [compareWith]="compareStopsByCode" [label]="dropOffStationText" [hasTrigger]="true" [displayErrors]="false"
          [customOptionTemplate]="optionTemplate" selectClass="!text-white" labelClass="!text-primary-gold"
          class="station-select rounded-lg text-white w-full text-start">
          <div trigger>
            <span class="!text-base">{{ getStopName(dropingStationFormControl.value) }} @if
              (dropingStationFormControl.value?.platformNumber) {
              <span class="!text-base">- {{ platformText }} {{ dropingStationFormControl.value?.platformNumber }}</span>
              }</span>
            <small class="text-sm">
              - {{ dropingStationFormControl.value?.stopcode }}</small>
          </div>
        </mot-select>
      </span>

      @if (!!showRoutePrice) {
      <app-tariff-profile-price [isInHeader]="true" [prices]="routePrices" [selectedProfile]="profile" />
      }
    </ng-container>
  </app-results-header>

  <div class="relative w-full rounded-t-xl bg-white overflow-y-auto flex-1" id="printableArea">
    <ng-container *ngTemplateOutlet="tabGroup" />
  </div>
</design-slide-up-card>

<ng-template #tabGroup>
  @if (isLoadingData) {
  <app-loader />
  }
  <mat-tab-group [dir]="direction" mat-stretch-tabs="false" [disableRipple]="true" class="h-full use-padding">
    <mat-tab>
      <ng-template mat-tab-label>{{ lineRouteText }}</ng-template>
      <app-search-line-detailed-result [line]="data.line" [boardingStation]="boardingStationFormControl.value"
        [dropingStation]="dropingStationFormControl.value" (onCalendarPickChange)="getTripCalendar($event)"
        (onTariffProfileChange)="profile = $event" (onToggleRoutePrice)="showRoutePrice = $event"
        (closeCardEvent)="closeCard()" (navigateToRouteEvent)="this.isNavigatingToRoute = $event" />
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>{{ dailyCalendarText }}</ng-template>
      <app-search-line-daily-calendar (onDayChange)="getRouteDailyCalendar($event)" [dailyCalendar]="dailyCalendar"
        [isLoadingCalendarData]="isLoadingCalendarData" [nextDayOfService]="nextDayOfService" />
    </mat-tab>

    @if (!!isMobile) {
    <mat-tab>
      <ng-template mat-tab-label>{{ showOnMapText }}</ng-template>
      <app-search-line-result-map />
    </mat-tab>
    }
  </mat-tab-group>
</ng-template>

<ng-template #optionTemplate let-opt>
  <div class="text-[#0C3058]">{{ getStopName(opt.value) }}</div>
  <small class="text-[#5C748F] text-sm font-normal">{{ stationCodeText }}: {{ opt.value.stopcode }}</small>
</ng-template>